"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useReducer, useRef } from "react";
import { ActionIcon, EyeIcon, EyeOffIcon } from "../../icons/index.js";
import useCombinedRefs from "../utils/use-combined-refs.js";
import Input from "./input.js";
export const PasswordInput = React.forwardRef(function PasswordInput(props, ref) {
    const [type, toggleType] = useReducer(state => (state === "text" ? "password" : "text"), "password");
    const innerRef = useRef(ref);
    const combinedRef = useCombinedRefs(ref, innerRef);
    function handleIconAction() {
        var _a;
        toggleType();
        (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    const icon = (props) => _jsx(ActionIcon, Object.assign({ active: true, icon: type === "text" ? EyeOffIcon : EyeIcon, onAction: handleIconAction }, props));
    return _jsx(Input, Object.assign({ ref: combinedRef }, props, { rightIcon: icon, type: type }));
});
export default PasswordInput;
//# sourceMappingURL=password-input.js.map